import { connect } from 'react-redux'
import get from 'lodash/get'

import { fetchArea } from '../../actions/areas'
import { loadIssuesForArea } from '../../actions/issues'

import {
  needsWorkSelector,
  needsReviewSelector,
  permanentSelector,
  resolvedSelector
} from '../../selectors/issue-selectors'

import IssuesList from '../../components/issues/issues-list'

function mapStateToProps (state, ownProps) {
  const pagination = get(state, `pagination.issuesByArea.${ownProps.params.servicingAreaId}`, {})

  return {
    needsWork: needsWorkSelector(state, "issuesByArea", ownProps.params.servicingAreaId),
    needsReview: needsReviewSelector(state, "issuesByArea", ownProps.params.servicingAreaId),
    permanent: permanentSelector(state, "issuesByArea", ownProps.params.servicingAreaId),
    resolved: resolvedSelector(state, "issuesByArea", ownProps.params.servicingAreaId),
    hasNextPage: pagination.nextPageUrl
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  let locationId

  const loadMore = (loadMore) => (
    dispatch(
      loadIssuesForArea(locationId, ownProps.params.servicingAreaId, loadMore)
    )
  )

  dispatch(fetchArea(ownProps.params.servicingAreaId))
    .then((action) => {
      locationId = action.payload.entities.areas[action.payload.result].locationId

      loadMore()
    })

  return {
    onLoadNextPage () {
      loadMore(true)
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssuesList)



// WEBPACK FOOTER //
// ./src/containers/issues/area-issues-list-container.js